<script lang="ts">
    import Dialog, {Actions, Content} from "@smui/dialog";
    import NauiButton from "../naui/atoms/NauiButton.svelte";
    import {createEventDispatcher} from "svelte";

    export let okLabel: string = 'ACEPTAR';
    export let cancelLabel: string = 'CANCELAR';

    const dispatch = createEventDispatcher();

    export let dialog: any = {
        open: false,
        message: ''
    }

    function accept() {
        cancel();
        dispatch('accept');
    }

    function cancel() {
        dialog = {
            open: false,
            message: ''
        }
    }
</script>
<Dialog bind:open={dialog.open}
        scrimClickAction=""
        escapeKeyAction=""
        aria-describedby="mandatory-content">
    <Content id="mandatory-content">
        {@html dialog.message}
    </Content>
    <Actions>
        <div class="box sx-1 w-100">
            <NauiButton caption={okLabel}
                        color="accent"
                        mode="solid"
                        on:click={()=> accept()}/>
            <NauiButton caption={cancelLabel}
                        mode="solid"
                        on:click={() => cancel()}/>
        </div>
    </Actions>
</Dialog>
